import React from "react";
import SpinnerHandler from "../../../hoc/SpinnerHandler/SpinnerHandler";
import useHttpSection from "../../../hooks/useHttpSection";
import { Link } from "react-router-dom";
import moment from "moment-jalaali";
import "./sectionStyle.scss";

const HydrometricTabs = {
  title: "ایستگاه هیدرومتریک",
  chart: "Chart/Hydrometric",
  values: [
    { value: "رودخانه" },
    { value: "نام" },
    { value: "کد" },
    { value: "دبی" },
  ],
  colors: ["#f3faf9", "#f9f3fa", "#f5f3fa", "#faf3f4"],
  widths: ["160px", "200px", "100px", "100px"],
  totalWidth: 850,
  items: {
    name: 3,
    code: 2,
    // river: 0,
    river_eng: 0,
    latest_update: {
      discharge: 1,
    },
  },
};

const HydrometricSection = (props) => {
  const { data, isLoading } = useHttpSection(props);
  const handleDate = (item) => {
    if (item) {
      if (item.date) {
        return moment(item.date).format("jYYYY/jMM/jDD");
      } else {
        return "";
      }
    } else {
      return "";
    }
  };
  return (
    <SpinnerHandler isLoading={isLoading}>
      <div className="topHeaderContainer">
        <ul className="listTab">
          {HydrometricTabs.values.map((e, i) => (
            <li
              style={{
                backgroundColor: HydrometricTabs.colors[i],
                width: HydrometricTabs.widths[i],
                fontWeight: "bolder",
                fontSize: 14,
              }}
              key={e.value}
            >
              {e.value}
            </li>
          ))}
        </ul>
        <div className="line topline">
          <div></div>
        </div>
      </div>
      {data?.map((item) => (
        <div className="rowContainer" key={item.id}>
          <div key={item.id} className="RowHydrometricContainer">
            <div style={{ display: "flex" }}>
              <div className="item1">
                <p>{item.river_eng}</p>
              </div>
              <div className="item2">
                <p>{item.name}</p>
              </div>
              <div className="item3">
                <p>{item.code}</p>
              </div>
              <div className="item4">
                <p>{item.latest_update && item.latest_update.discharge}</p>
                <p style={{ fontSize: 10 }}>
                  {item.latest_update &&
                  (item.latest_update.discharge === 0 ||
                    item.latest_update.discharge)
                    ? handleDate(item.latest_update)
                    : ""}
                </p>
              </div>
            </div>
            <div className="buttonBox">
              <Link
                className="link"
                to={{
                  pathname: "Chart/Hydrometric",
                  state: { name:HydrometricTabs.title + " " + item.name, id: item.id},
                }}
              >
                <div className="buttonFullData">اطلاعات کامل</div>
              </Link>
            </div>
          </div>
          <div className="line">
            <div></div>
          </div>
        </div>
      ))}
      {!data.length && !isLoading && (
        <div className="noItemContainer">
          <p>هیچ موردی یافت نشد</p>
        </div>
      )}
    </SpinnerHandler>
  );
};

export default HydrometricSection;
